module.exports = "/dist/img/noshi02.56f235c6.jpg";